export default "__VITE_ASSET__3cKQC4yA__"